import React from 'react';
import ReactDOM from 'react-dom';
import ValuePicker from './picker/ValuePicker';
import { Modal } from 'react-bootstrap';
import ValueSource from '../../../sources/value';
import ValueEditorContainer from './picker/views/singleValue/ValueEditorContainer';
import { contentTypes } from '../../../constants';
import { dataToValueOption, ELEMENT_TYPES, addRecentValueReferenceId } from './picker/valuePickerUtils';

const renderValueEditor = props => <ValueEditorContainer valueId={props.elementId} {...props} />;

/**
 * @param editor TinyMCE editor instance
 * @description A component that wraps the value picker in a modal
 * and provides the value picker with a callback for injecting
 * value references into TinyMCE
 */
export default class TinyMCEvalueSelector extends React.Component {
    state = {
        show: true,
    };

    modalContainer = document.getElementById('generic-modal')

    onClose = () => {
        this.setState({
            show: false,
        }, () => {

            // This is because the component does not
            // unmount when the modal closes and the
            // user then decides to insert another value into the editor.
            // The delay allows for the modal to close with a smooth animation
            // before the node is removed from the DOM.
            setTimeout(() => {
                ReactDOM.unmountComponentAtNode(this.modalContainer);
            }, 1000);
        });
    };

    onChange = (value) => {
        const { developerName, typeElementPropertyDeveloperName } = value;

        const content = manywho.utils.isNullOrEmpty(typeElementPropertyDeveloperName) ?
            `{![${developerName.replace(/ /g, '&nbsp;')}]}` :
            `{![${developerName.replace(/ /g, '&nbsp;')}].[${typeElementPropertyDeveloperName.replace(/ /g, '&nbsp;')}]}`;

        this.props.editor.insertContent(content);

        if (value) {
            const elementMeta = dataToValueOption(value);

            // Construct a new value reference object
            const newValueReference = {
                valueId: elementMeta.id,
                propertyId: elementMeta.propertyId,
            };

            addRecentValueReferenceId(newValueReference);
        }

        this.onClose();
    };

    renderValue = ({ elementName, elementMeta }) => (
        <div className="value-option">
            <div>{ elementName }</div>
            <div className="value-picker-meta">{ elementMeta }</div>
        </div>
    );

    render() {
        return (
            <Modal
                show={this.state.show}
                container={this.modalContainer}
                bsSize="small"
                className="picker-modal"
            >
                <ValuePicker
                    close={this.onClose}
                    select={this.onChange}
                    renderOption={this.renderValue}
                    elementType={ELEMENT_TYPES.value}
                    getList={ValueSource.getList}
                    renderSingleElement={renderValueEditor}
                    contentTypeFilter={
                        Object.values(contentTypes)
                            // We don't want to show Password or Encrypted Values to reference
                            .filter(type => type.toUpperCase() !== 'CONTENTPASSWORD' && type.toUpperCase() !== 'CONTENTENCRYPTED')
                    }
                />
            </Modal>
        );

    }
}
